export class Filters {
  stars: number;
  priceMin: number;
  priceMax: number;
  priceMinFlight: number;
  priceMaxFlight: number;
  lodgingType: "room" | "apartment" | "all";
  breakfast: boolean;
  requestFlight: boolean;
  requestTrain: boolean;
  requestCustomFlight?: boolean;
  requestCustomBooking?: boolean;
  requestCustomAirbnb?: boolean;
  requestCustomTrain?: boolean;
  requestCar?: boolean;
  onlyAuthorization?: boolean;
  onlyFlightAuthorization?: boolean;
  onlyTrainAuthorization?: boolean;
  requestBooked: boolean;
  // política de clase comentada hasta cambio de proveedor
  // sitType?: "ECONOMY" | "PREMIUM_ECONOMY" | "BUSINESS" | "CLASS_FIRST";
  renfeCard?: "PLUS50" | "GOLDENCARD" | "ALL";
  hotelDaysInAdvance?: number;
  flightDaysInAdvance?: number;
  trainDaysInAdvance?: number;
}
